import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ReactGA from 'react-ga';

import { tabResultState } from '../../../modules/tabResult';
import { GetPopularKeywordParamType } from '../../../lib/tabResult/type';
import { searchKeywordState } from '../../../modules/searchKeyword';
import { media } from '../../common/Layout';

type StyledType = {
  isSelectButton: boolean;
};

const PopularKeywordComponent = styled.div`
  margin-top: 10px;
  width: 100%;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
  padding: 20px;
`;

const PopularKeywordTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const PopularKeywordTitleText = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

const ButtonGroup = styled.div`
  display: flex;
`;

const ButtonTerm = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  cursor: pointer;
  & + & {
    margin-left: 6px;
  }
  ${(props: StyledType) => {
    if (props.isSelectButton) {
      return css`
        text-decoration: underline;
        font-weight: 500;
        color: #000000;
      `;
    }
    return css``;
  }}
`;

const RankContainer = styled.div`
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;

  ${media.desktop`  
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  `};
`;

const RankHalfContainer = styled.div`
  /* Mobile Device */
  flex: 1 1 40%;

  ${media.desktop`  
    flex: 1 1 100%;
  `};
`;

const ItemContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const ItemRanking = styled.div`
  font-size: 14px;
  width: 15px;
  min-width: 15px;
  font-weight: bold;
  text-align: right;
`;

const ItemText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #333333;
  margin-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

interface PopularKeywordProps extends RouteComponentProps {
  popularKeyword: tabResultState['popularKeyword'];
  onGetPopularKeyword: (info: GetPopularKeywordParamType) => void;
  onSetSearchKeyword: (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => void;
}

type PopularKeywordState = {
  isWeek: boolean;
  isMonth: boolean;
};

class PopularKeyword extends React.PureComponent<
  PopularKeywordProps,
  PopularKeywordState
> {
  state = {
    isWeek: true,
    isMonth: false,
  };

  makeList = (count: number): ReactNode[] | null => {
    const { popularKeyword } = this.props;
    const result: ReactNode[] | null = [];

    popularKeyword.forEach((element, index) => {
      if (index < count + 5 && index >= count) {
        result.push(
          <ItemContainer>
            <ItemRanking>{index + 1}</ItemRanking>
            <ItemText
              onClick={() => {
                this.onClickItem(element);
              }}
            >
              {element}
            </ItemText>
          </ItemContainer>
        );
      }
    });

    return result;
  };

  onClickItem = (element: string) => {
    const { history } = this.props;
    ReactGA.ga('send', 'event', `click_search_result_인기검색어`);

    history.push(`/search/result?q=${element}`);
    window.location.reload(true);
  };

  onClickTab = (tabId: number) => {
    const { onGetPopularKeyword } = this.props;
    switch (tabId) {
      case 0:
        this.setState({
          isWeek: true,
          isMonth: false,
        });
        onGetPopularKeyword({ date_unit: 'week', count: 10 });
        break;
      case 1:
        this.setState({
          isWeek: false,
          isMonth: true,
        });
        onGetPopularKeyword({ date_unit: 'month', count: 10 });
        break;
      default:
        this.setState({
          isWeek: true,
          isMonth: false,
        });
        onGetPopularKeyword({ date_unit: 'week', count: 10 });
        break;
    }
  };

  render() {
    const { isMonth, isWeek } = this.state;
    return (
      <PopularKeywordComponent>
        <PopularKeywordTitleBox>
          <PopularKeywordTitleText>인기검색어</PopularKeywordTitleText>
          <ButtonGroup>
            <ButtonTerm
              isSelectButton={isWeek}
              onClick={() => {
                this.onClickTab(0);
              }}
            >
              주간
            </ButtonTerm>
            <ButtonTerm
              isSelectButton={isMonth}
              onClick={() => {
                this.onClickTab(1);
              }}
            >
              월간
            </ButtonTerm>
          </ButtonGroup>
        </PopularKeywordTitleBox>
        <RankContainer>
          <RankHalfContainer>{this.makeList(0)}</RankHalfContainer>
          <RankHalfContainer>{this.makeList(5)}</RankHalfContainer>
        </RankContainer>
      </PopularKeywordComponent>
    );
  }
}

export default withRouter(PopularKeyword);
